<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Entrada de producto</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Bodega</a></li>
        <li class="breadcrumb-item active">Ingreso de producto</li>
      </ol>
    </div>
    <div class="card">
      <!-- <div class="card-header">
        <button type="button" class="btn btn-theme">Nueva venta</button>
      </div> -->
      <div class="card-body">
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>Documento</th>
              <th>Comprador</th>
              <th>Proveedor</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Fecha de entrega</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="purchase in purchases" :key="purchase.id">
              <td>{{ purchase.document }}</td>
              <td>{{ purchase.nameBuyer }}</td>
              <td>{{ purchase.companyProvider }}</td>
              <td>
                <span v-if="purchase.deliveryStatus===0" class="btn btn-danger btn-sm">Anulado</span>
                <span v-if="purchase.deliveryStatus===2" class="btn btn-warning btn-sm">Pendiente</span>
                <span v-if="purchase.deliveryStatus===1" class="btn btn-success btn-sm">Comprobado</span>
              </td>
              <td>{{ convertDate(purchase.purchase_date) }}</td>
              <td>{{ convertDate(purchase.delivery_date) }}</td>
              <td class="btn-group mr-2" role="group" aria-label="First group">
                <!-- <button class="btn btn-danger" v-tooltip.top-center="'Anular compra'" @click="openModal(purchase.id)" v-if="purchase.state!=0">
                  <i class="icon-fa icon-fa-trash"/>
                </button> -->
                <router-link
                  v-if="purchase.deliveryStatus===2"
                  v-tooltip.top-center="'Ver compra'"
                  :to="`/admin/bodega/recibir?id=${purchase.id}`"
                  class="btn btn-success">
                <i class="icon-fa icon-fa-eye"/></router-link>
              </td>
            </tr>
            <!-- <tr v-for="sale in sales" :key="sale.id">
              <td>{{ sale.document.name }}-{{ sale.document_number }}</td>
              <td>{{ sale.seller.name }}</td>
              <td>{{ sale.nameReference }}</td>
              <td>{{ mymoney(sale.total) }}</td>
              <td>
                <span v-if="sale.state===0" class="btn btn-danger btn-sm">Anulado</span>
                <span v-if="sale.state===2" class="btn btn-warning btn-sm">Pendiente</span>
                <span v-if="sale.state===1" class="btn btn-success btn-sm">Pagado</span>
              </td>
              <td>{{ convertDate(sale.created_at) }}</td>
              <td>
                <template>
                  <div> -->
                    <!-- <button :href="`#${category.name}`" class="btn btn-theme" @click="openModal('update', category)"><i class="icon-fa icon-fa-pencil"/> Editar </button>  -->
                    <!-- <template v-if="sale.state!=0">
                      <button
                        v-tooltip.top-center="'Anular venta'"
                        class="btn btn-danger">
                        <i class="icon-fa icon-fa-trash" @click="openModal(sale.id)"/>
                      </button>
                    </template> -->
                    <!-- <router-link
                      v-tooltip.top-center="'Cobrar venta'"
                      v-if="sale.state===2"
                      :to="`/admin/venta/cobrar?id=${sale.id}`"
                      class="btn btn-warning"
                    > -->
                    <!-- <i class="icon-fa icon-fa-shopping-cart"/></router-link> -->
                    <!-- <router-link
                      v-tooltip.top-center="'Ver venta'"
                      :to="`/admin/bodega/entrega?id=${sale.id}`"
                      class="btn btn-success">
                    <i class="icon-fa icon-fa-eye"/></router-link> -->
                    <!-- <button
                      v-tooltip.top-center="'Imprimir venta'"
                      v-if="sale.state===1"
                      class="btn btn-primary"><i class="icon-fa icon-fa-print"/></button> -->
                  <!-- </div>
                </template>
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import ladda from 'ladda'
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { xelacode } from '../../../helpers/xelacode'
export default {
  components: {
    SweetModal,
    SweetModalTab
  },
  data () {
    return {
      purchases: [],
      user: {},
      idPurchase: 0
    }
  },
  mounted () {
    this.getPurchases()
    this.getUser()
  },
  methods: {
    getPurchases () {
      axios.get('/api/purchase/indexDel')
        .then((response) => {
          // console.log(response)
          this.purchases = response.data
        }).catch((error) => {
          console.log(error)
        })
    },
    convertDate (date) {
      return new Date(date).toLocaleString('es-GT', {timeZone: 'America/Guatemala'})
    },
    getUser () {
      let me = this
      axios.get('/api/sale/getUser')
        .then((response) => {
          me.user = response.data
        }).catch((error) => {
          console.log(error)
        })
    },
    mymoney (value) {
      return xelacode.money(parseFloat(value))
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/cellar/deliveryIn.vue